export default {"src":"/_next/static/media/search_icon.d7c6b148.svg","height":20,"width":20};